export default __webpack_public_path__ + "static/media/noMoreSchedule.6fe7f4c6.svg";